import * as React from "react";
import type { SVGProps } from "react";
const SvgChild = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M13.783 8.707A1 1 0 0 0 15.49 8a9.15 9.15 0 0 0-2.2-5.6 1 1 0 1 0-1.6 1.2 7.15 7.15 0 0 1 1.8 4.4 1 1 0 0 0 .293.707ZM11 9a1 1 0 0 1-1-1 6 6 0 0 0-2-4.17 1 1 0 0 1 .357-1.809 1 1 0 0 1 .753.149A7.88 7.88 0 0 1 12 8a1 1 0 0 1-1 1Z"
    />
    <path
      fill="currentColor"
      d="M8.93 22.52c.993.317 2.028.479 3.07.48a9.93 9.93 0 0 0 4.62-1.11 10 10 0 0 0 4.82-5.45 3.499 3.499 0 0 0 1-1.05 3.439 3.439 0 0 0 .48-2.63 3.45 3.45 0 0 0-1.16-1.94 10.07 10.07 0 0 0-4.21-6.15 1 1 0 0 0-1.534 1.028 1 1 0 0 0 .424.632 8 8 0 0 1 3.43 5.24 1 1 0 0 0 .44.66 1.51 1.51 0 0 1 .66.95 1.47 1.47 0 0 1-.21 1.12 1.5 1.5 0 0 1-.62.55 1 1 0 0 0-.52.6 8 8 0 0 1-10.07 5.16 8 8 0 0 1-5.17-5.16.94.94 0 0 0-.52-.6 1.51 1.51 0 0 1-.72-2 1.54 1.54 0 0 1 .54-.62.94.94 0 0 0 .44-.66A8.11 8.11 0 0 1 7.45 6.4a1 1 0 0 0 .26-1.39 1 1 0 0 0-1.39-.25 10 10 0 0 0-4.08 6.06A3.4 3.4 0 0 0 1.33 12a3.51 3.51 0 0 0 1.27 4.44 10 10 0 0 0 6.33 6.08Z"
    />
    <path
      fill="currentColor"
      d="M10.253 18.7a4.49 4.49 0 0 0 1.747.35 4.46 4.46 0 0 0 3.1-1.3l.07-.07a1 1 0 1 0-1.44-1.39 2.5 2.5 0 0 1-3.53 0 1.001 1.001 0 1 0-1.42 1.41c.42.429.92.769 1.473 1ZM10 15a1 1 0 0 1-1-1v-1a1 1 0 1 1 2 0v1a1 1 0 0 1-1 1ZM13.293 14.707A1 1 0 0 0 15 14v-1a1 1 0 0 0-2 0v1a1 1 0 0 0 .293.707Z"
    />
  </svg>
);
export default SvgChild;
